import React, { useState, useEffect } from "react";
import Modal from "../../../components/ui/Modal";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";
import Button from "../../../components/ui/Button";

// The modal now accepts an optional 'userToEdit' prop
const CreateUserModal = ({ isOpen, onClose, onSave, userToEdit, roles }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("Fan");

  const isEditMode = !!userToEdit;

  useEffect(() => {
    if (isEditMode && isOpen) {
      setName(userToEdit.name);
      setEmail(userToEdit.email);
      setRole(userToEdit.role);
    } else {
      setName("");
      setEmail("");
      setRole("Fan");
    }
  }, [isOpen, userToEdit, isEditMode]);

  const handleSaveClick = () => {
    if (!name || !email) return;

    const userData = {
      id: isEditMode ? userToEdit.id : `U-${Math.floor(Math.random() * 1000)}`,
      name,
      email,
      role,
      status: isEditMode ? userToEdit.status : "Active",
      joinDate: isEditMode
        ? userToEdit.joinDate
        : new Date().toISOString().split("T")[0],
    };
    onSave(userData);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isEditMode ? "Edit User" : "Add New User"}
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Full Name
          </label>
          <Input
            placeholder="e.g., Aster Aweke"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Email Address
          </label>
          <Input
            type="email"
            placeholder="e.g., aster@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Role</label>
          <Select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            options={roles ? roles.map(r => ({ value: r.name, label: r.name })) : [
              { value: "Fan", label: "Fan" },
              { value: "Creator", label: "Creator" },
            ]}
          />
        </div>
        <div className="flex justify-end pt-4 space-x-3">
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveClick}>
            {isEditMode ? "Save Changes" : "Save User"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateUserModal;
